/* WRLD TAGS cart drawer restyle (UpCart). Loaded on every page from layout/theme.liquid.
   HARD RULE (Sept 10, 2026): the UpCart drawer renders inside an open shadow root on #upCart, so no
   stylesheet in the page reaches it. This script fetches assets/wt-cart-drawer.css once and appends it
   as a <style> INSIDE that shadow root, and re-appends it if UpCart rebuilds the root. Change the look
   in wt-cart-drawer.css only; never move those rules into a page stylesheet (they would do nothing). */
(function () {
  'use strict';
  var el = document.currentScript || document.querySelector('script[data-css][src*="wt-cart-drawer"]');
  var href = el && el.getAttribute('data-css');
  if (!href) return;
  var css = null;

  function apply() {
    var host = document.getElementById('upCart');
    var root = host && host.shadowRoot;
    if (!root || css === null) return false;
    if (root.getElementById('wt-cart-drawer-style')) return true;
    var st = document.createElement('style');
    st.id = 'wt-cart-drawer-style';
    st.textContent = css;
    root.appendChild(st);
    return true;
  }

  function watch() {
    var host = document.getElementById('upCart');
    if (!host || !host.shadowRoot) return;
    new MutationObserver(function () { apply(); }).observe(host.shadowRoot, { childList: true });
  }

  fetch(href).then(function (r) { return r.text(); }).then(function (t) {
    css = t;
    if (apply()) { watch(); return; }
    // UpCart mounts after load; poll briefly, then watch the body for the host.
    var tries = 0;
    var timer = setInterval(function () {
      if (apply() || ++tries > 100) { clearInterval(timer); watch(); }
    }, 200);
    var mo = new MutationObserver(function () {
      if (apply()) { mo.disconnect(); clearInterval(timer); watch(); }
    });
    mo.observe(document.documentElement, { childList: true, subtree: true });
  }).catch(function () {});
})();
